export const teamMembers = [
    {
        name: "Dr. Muzakkir Hussain",
        role: "Assistant Professor",
        department: "Department of Computer Science and Engineering",
        img: "/images/muzakkir.jpg"
    },
    {
        name: "Dr. Firoj Gazi",
        role: "Assistant Professor",
        department: "Department of Computer Science and Engineering",
        img: "/images/firojgazi.jpeg"
    },
    {
        name: "Dr. Mohammad Abdussami",
        role: "Assistant Professor",
        department: "Department of Computer Science and Engineering",
        img: "/images/sami sir.jpg"
    },
    {
        name: "Dr Sahadeb Shit",
        role: "Assistant Professor",
        department: "Department of Computer Science and Engineering",
        img: "/images/sahadeb.png"
    },
    {
        name: "Ms Surayya",
        role: "PhD Scholar",
        img: "/images/Surayya-A.jpg"
    },
    {
        name: "Siripalli Hemanth Durga Kumar",
        role: "PhD Scholar",
        img: "/images/hemanth.jpg"
    },
    {
        name: "Madhu Bhushan",
        role: "PhD Scholar",
        img: "/images/madhu.jpg"
    },
    {
        name: "Sultan Khan",
        role: "PhD Scholar",
        img: "/images/sulthan.jpg"
    },
    {
        name: "Sasikanth",
        role: "PhD Scholar",
        img: "/images/sasikanth.png" // Placeholder as requested
    }
];

export const alumniMembers = [
    {
        name: "Dr. Aswani Devi",
        role: "Alumni / Former Assistant Professor",
        department: "Department of Computer Science and Engineering",
        img: "/images/ashwini.jpg"
    },
    {
        name: "Nandhini",
        role: "Alumni / Former PhD Scholar",
        img: "/images/nandhini.jpg"
    },
    {
        name: "Priya",
        role: "Alumni - Class of 2025",
        img: "/images/priya.jpg"
    },
    {
        name: "Fazal",
        role: "Alumni - Class of 2025",
        img: "/images/fazal.jpg"
    }
];
